import { Pill } from "./score-viz";

export function ConfidenceBadge({ confidence }: { confidence: string }) {
  switch (confidence) {
    case "HIGH":
      return <Pill tone="success">HIGH</Pill>;
    case "MEDIUM":
      return <Pill tone="ambig">MEDIUM</Pill>;
    case "LOW":
      return <Pill tone="failed">LOW</Pill>;
    default:
      return <Pill tone="default">{confidence}</Pill>;
  }
}
